











































































































import VueOptions from '@utils/VueOptions'
settings =
  name: 'OfferResourceListItem'
  vue:
    props: ['item', 'rowSize', 'actions', 'selected', 'backgroundColor']

    computed:
      audienceListing: -> @ctxAudienceListing @item
      audienceListingId: -> @audienceListing?.id
      audienceListingOwner: -> @audienceListing?.owner

      activationDate: ->
        return '' unless @item.activation_plan?.available_dates?.length
        dates = @item.activation_plan.available_dates.sort((a, b) => new Date(a.starts_on) - new Date(b.starts_on))
        startDate = dates[0]?.starts_on
        endDate = dates[dates.length - 1]?.starts_on
        @$options.filters.formatDateWindow startDate, endDate

    methods:
      shouldExpandCollumn: (size, eventId) ->
        return true if @rowSize >= 2 && size == 'MEDIUM'
        return true if @rowSize == 3 && size == 'LARGE'

export default VueOptions.vue settings
